import React from "react";
import { IoMdClose } from "react-icons/io";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";

const QuickBuyBetInCompleteDetailsPopup = (props) => {
    const country_name = useSelector((state) => state.CommonConfig.country_name);
    const { onClose } = props;

    return (
        <div className="overlay">
            <div className='overlay_innerDiv' onClick={onClose}></div>
            <div className="informasi_popup quickbuy_betdetail_popup">
                <button className="informasi_popup-close" onClick={onClose}>
                <IoMdClose className="btnclose"/>
                </button>
                <div className="details_txt">Detail Bet (QUICK BUY - {country_name})</div>
                <div className="quickbetdetails">{props.t('bet_details')}</div>
                <div className="total_all"><span className="total_txt">Total</span><span className="toal_no">0</span></div>
                <div className="incomplete_txt">{props.t('incomplete_format')}</div>
                <div className="bet_no">{props.response.number}</div>
                <p className="note">{props.t('quickbuy_note')}</p>

                <div className='btn_section'>
                    <ul className="button-list">
                        <li>
                            <button className="reset" onClick={onClose}>No</button>
                        </li>
                        <li>
                            <button className="submit">Yes</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default withTranslation()(QuickBuyBetInCompleteDetailsPopup);
